import cloneDeep from 'lodash/cloneDeep';
import { types as authentication } from './authentication';

const MODULE_PREFIX = 'portfolioV2';

const GETTER_PORTFOLIOS = 'portfolios';

const MUTATION_PORTFOLIOS = 'updatePortfolios';

const ACTION_FETCH_PORTFOLIOS = 'fetchPortfolios';

const initialState = {
  portfolios: {},
};

const getters = {
  [GETTER_PORTFOLIOS]: (state) => state.portfolios,
};

const mutations = {
  [MUTATION_PORTFOLIOS]: (state, value) => { state.portfolios = value; },
};

const actions = {
  [ACTION_FETCH_PORTFOLIOS]: async ({ commit, rootGetters }) => {
    const userPortfolio = {
      id: rootGetters[authentication.getters.userId],
      name: undefined,
    };
    const groups = rootGetters[authentication.getters.groups];
    const groupPortfolios = cloneDeep(groups).sort((a, b) => a.name.localeCompare(b.name));

    commit(MUTATION_PORTFOLIOS, [userPortfolio, ...groupPortfolios]);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export const types = {
  getters: {
    portfolios: `${MODULE_PREFIX}/${GETTER_PORTFOLIOS}`,
  },
  mutations: {
  },
  actions: {
    fetchPortfolios: `${MODULE_PREFIX}/${ACTION_FETCH_PORTFOLIOS}`,
  },
};
